



















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { DashboardExpiringDocument } from '../../types/dashboard-expiring-document';
import ExpiringSoonWidget from '../widgets/expiring-soon/components/ExpiringSoonWidget.vue';
import LatestActivitiesWidget from '../widgets/latest-activity/components/LatestActivitiesWidget.vue';
import UnopenedDocumentsWidget from '../widgets/components/UnopenedDocumentsWidget.vue';
import SignedDocumentsWidget from '../widgets/components/SignedDocumentsWidget.vue';
import ExpiredDocumentsWidget from '../widgets/components/ExpiredDocumentsWidget.vue';
import ActiveDocumentsWidget from '../widgets/components/ActiveDocumentsWidget.vue';

export default defineComponent({
  components: {
    LatestActivitiesWidget,
    ExpiringSoonWidget,
    UnopenedDocumentsWidget,
    SignedDocumentsWidget,
    ExpiredDocumentsWidget,
    ActiveDocumentsWidget,
  },
  props: {
    showAll: {
      type: Boolean,
    },
    expiringDocuments: {
      type: Array as PropType<DashboardExpiringDocument[]>,
      default: null,
    },
  },
});
